import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSpectrumRough = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 61 61",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.83 50.346h24.704a.35.35 0 0 0 .317-.206l8.942-16.819a.35.35 0 0 0-.02-.355L34.894 8.04a.35.35 0 0 0-.285-.152l-12.644-.025a.35.35 0 0 0-.276.138L9.461 24.662a.35.35 0 0 0-.05.31l8.09 25.135a.35.35 0 0 0 .33.24m24.86-1.375L35.259 9.81l15.827 23.37zM33.476 8.576 11.177 23.49 22.142 8.55zM10.406 25.813l31.11 23.843H18.083zm31.619 23.363-31.693-24.29L34.365 8.813z" })
});
export default SvgSpectrumRough;
